import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { copyToClipboard } from 'libs/common';
import { getFiscalQr } from 'services/payments-service';
import { Loader2, Popup2 } from 'libs/ui';
import { Content, Error, Info } from './qr.styled';

export const Qr = (props) => {
  const { close, id } = props;
  const textRef = useRef(null);
  const { t } = useTranslation();

  const [ready, setReady] = useState(false);
  const [qr, setQr] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    getFiscalQr(id)
      .then((data) => {
        if (!data) {
          setQr('');
          setError(t('errors.QR по данной операции отсутствует'));
        } else {
          setQr(data);
          setError('');
        }
      })
      .catch((error) => {
        setQr('');
        setError(error.toString());
      })
      .finally(() => {
        setReady(true);
      });
  }, [id]);

  /**
   * select text
   */
  const select = () => {
    if (textRef.current) {
      const range = document.createRange();
      range.selectNodeContents(textRef.current);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
    }
    copyToClipboard(qr.qrcode);
  };

  const closePopup = () => {
    close();
  };

  const fn = 'data:image/png;base64,' + qr.base64;
  return (
    <Popup2 close={closePopup} w={320}>
      <Content>
        {!ready ? (
          <Loader2 height={'250px'} />
        ) : error ? (
          <Error>{error}</Error>
        ) : (
          <>
            <img src={fn} alt={'qr'} />
            <Info onClick={select} ref={textRef} title={t('messages.Кликните для выделения и копирования')}>
              {qr.qrcode}
            </Info>
          </>
        )}
      </Content>
    </Popup2>
  );
};
